import { useEffect } from 'react';

/**
 * 모달/팝업 공통 — Escape 키로 닫기
 *
 * @param {boolean} open 열린 상태일 때만 리스너 등록
 * @param {() => void} onClose 닫기 콜백
 * @param {{ enabled?: boolean }} [options] enabled=false면 무시 (중첩 확인 등)
 *
 * @example
 * useEscapeClose(open, onClose);
 * useEscapeClose(deptPopupOpen, () => setDeptPopupOpen(false));
 */
export function useEscapeClose(open, onClose, options = {}) {
  const enabled = options.enabled !== false;

  useEffect(() => {
    if (!open || !enabled || typeof onClose !== 'function') return undefined;

    const handleKeyDown = (e) => {
      if (e.key !== 'Escape') return;
      // 셀 편집·중첩 팝업이 capture에서 먼저 처리할 수 있으므로,
      // 여기서는 기본동작·전파를 막아 상위 핸들러와 충돌을 줄인다.
      e.preventDefault();
      e.stopPropagation();
      onClose();
    };

    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [open, onClose, enabled]);
}

export default useEscapeClose;
